(function() {
'use strict';

angular
    .module('searchUnit')
    .controller('SharedSearchUnit', SharedSearchUnit);

function SharedSearchUnit(sharedSearchUnitService) {
    const su = this;
    su.showErrors = errors => sharedSearchUnitService.showErrors(errors);
    su.lockScreen = searchMsg => sharedSearchUnitService.lockScreen(searchMsg);
    su.unlockScreen = () => sharedSearchUnitService.unlockScreen();
}
})();
